import { RouteItem } from '@eastcoal/router/types/route'

import { TENDER_AUCTION_CREATE_PAGE_PATH } from '../constants/path'

export const tenderAuctionCreateRoute: RouteItem = {
  title: '新增招标',
  hideInMenu: true,
  path: TENDER_AUCTION_CREATE_PAGE_PATH,
  Component: () => import('./index')
}
